// Module
var code = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" height=\"150\" width=\"410\" ng-attr-view_box=\"{{ $ctrl.signature.svgViewbox }}\"> <path stroke-width=\"2\" stroke=\"black\" ng-attr-d=\"{{ $ctrl.signature.signaturePaths }}\"> </path></svg> ";
// Exports
export default code;